export default __webpack_public_path__ + "static/media/pixel_me.e3f032b8.gif";